/* src/app/core/layout/components/navigation-item/navigation-item.component.scss */
/*# sourceMappingURL=navigation-item.component-X6TZMSJV.css.map */
